/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityRelationOrderBy = {
    MonitType: 'monit_type',
    AssetsCount: 'assets_count',
    DataleaksCount: 'dataleaks_count',
    HomoglyphsCount: 'homoglyphs_count',
    SinkholeCount: 'sinkhole_count',
    TorrentsCount: 'torrents_count',
    VulnerabilitiesCount: 'vulnerabilities_count',
    HomoglyphsDeltaCount: 'homoglyphs_delta_count',
    SinkholeDeltaCount: 'sinkhole_delta_count',
    TorrentsDeltaCount: 'torrents_delta_count',
    RiskScore: 'risk_score',
    RiskScoreV2: 'risk_score_v2',
    ReportUrl: 'report_url',
    Created: 'created',
    Updated: 'updated',
    EntityName: 'entity_name',
    Scanned: 'scanned'
} as const;
export type MonitEntityRelationOrderBy = typeof MonitEntityRelationOrderBy[keyof typeof MonitEntityRelationOrderBy];


export function MonitEntityRelationOrderByFromJSON(json: any): MonitEntityRelationOrderBy {
    return MonitEntityRelationOrderByFromJSONTyped(json, false);
}

export function MonitEntityRelationOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityRelationOrderBy {
    return json as MonitEntityRelationOrderBy;
}

export function MonitEntityRelationOrderByToJSON(value?: MonitEntityRelationOrderBy | null): any {
    return value as any;
}

